import React from 'react';
import { useSelector } from 'react-redux';

import { usePagination } from '../../utils';
import { PaginationWithReadMore } from '../../components/PaginationWithReadMore';
import { selectAuthorArticles } from '../../selectors/authorArticles';
import { ERequestStatus } from '../../types/requestStatus';

/**
 * Контейнер пагинации для статей автора
 */
export const AuthorArticleListPaginationContainer = () => {
  const {
    meta: { total, limit },
    status: listingStatus,
  } = useSelector(selectAuthorArticles);
  const { totalPages, activePageNumber: activeNumber, changePageNumber } = usePagination({ total, limit });

  return (
    <div data-web-ui-test-id="PaginationContainer">
      <PaginationWithReadMore
        activeNumber={activeNumber}
        totalPages={totalPages}
        onClick={changePageNumber}
        isDisabled={listingStatus === ERequestStatus.Loading}
      />
    </div>
  );
};
